import React from 'react';
import ActividadProfesional from "../components/consultoras";

function Bio() {
  return (
    <div className="bio-page">
      {/* Hero Section */}
      <section className="bio-hero bg-light"  style={{ paddingTop: '5rem', paddingBottom: '5rem' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-4">Sebastián Menescaldi</h1>
              <p className="lead text-muted text-justify mb-3">
                Economista dedicado al asesoramiento económico a empresas, bancos y compañías financieras. Actualmente Director Asociado de Eco Go Consultores, apoyado por un excelente equipo de profesionales.
              </p>
              <p className="lead text-muted text-justify mb-3">
                   Aprovecho mi experiencia en entidades financieras y en el sector público para explicar la coyuntura y dilucidar las perspectivas económicas más probables (y los posibles desvíos) a partir de un análisis integrado de la economía nacional.
                </p>
              <div className="d-flex gap-3">
                <a href="https://www.linkedin.com/in/smenescaldi/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                  <i className="bi bi-linkedin me-2"></i>LinkedIn
                </a>
                <a href="https://x.com/smenescaldi" target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark">
                  <i className="bi bi-twitter-x me-2"></i>Seguir en X
                </a>
              </div>
            </div>
            <div className="col-lg-4 text-center mt-4 mt-lg-0">
              <img 
                src="/seba-perfil.jpg" 
                alt="Sebastián Menescaldi" 
                className="img-fluid rounded-circle shadow"
                style={{ maxWidth: '350px', objectFit: 'cover', aspectRatio: '1/1' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Biografía Detallada */}
      <section className="bio-content py-5">
        <div className="container">
          <div className="row align-items-center mb-2"> 
            <div className="col-lg-7 order-2 order-lg-1">
              {/* Foto secundaria */}
              <div className="bio-imagen-trayectoria card border-0 shadow-sm mb-5 mb-lg-0">
                <img 
                  src="/seba-trabajo.jpg" 
                  alt="Sebastián en conferencia" 
                  className="card-img-top"
                  style={{ height: '400px', objectFit: 'cover' }}
                />
              </div>
            </div>
               {/* Columna trayectoria */}
            <div className="col-lg-5 ps-lg-5 order-1 order-lg-2">
              <div className="bio-trayectoria content-block mb-5">
                <h2 className="h3 fw-bold mb-4">Trayectoria Profesional</h2>
                <p className="text-justify lh-lg">
                  Trabajé en la Gerencia de Coyuntura Económica del BCRA hasta 2011. Desde entonces pasé a desempeñarme en el área de Research de BAPRO, liderando el equipo macroeconómico del Banco y asesorando tanto al Directorio como a la línea gerencial. Cofundé IES Consultores, especializada en análisis sectorial con una trayectoria de más de 20 años. 
                </p>
                <p className="text-justify lh-lg">
                  En simultáneo al seguimiento de la macroeconomía trabajé en diversos proyectos enfocados en la economía real destacándose, entre otros, el armado del plan de negocios de la candidatura ganadora de la Expo 2023 Buenos Aires Argentina en la Oficina Internacional de Exposiciones (BIE, por sus siglas en francés).
                </p>
              </div>
            </div>
          </div>

          <hr className="mt-5 mb-4 border-secondary opacity-75" />
                <div className="specialization mb-0">
                <h2 className="h3 fw-bold text-center pt-3 mb-4">Áreas de Especialización</h2>
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-clipboard2-data text-economista me-2"></i>
                          Escenarios Macroeconómicos
                        </h5>
                        <p className="card-text text-muted">
                          Seguimiento de la coyuntura y las perspectivas de mediano plazo de la economía argentina y del contexto internacional.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-graph-up text-economista me-2"></i>
                          Planes de Negocio
                        </h5>
                        <p className="card-text text-muted">
                          Diseño de estrategias para la administración de carteras de inversión y financieras consistentes con el escenario macroeconómico.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-body-text text-economista me-2"></i>
                          Análisis sectorial
                        </h5>
                        <p className="card-text text-muted">
                          Especialista en dinámicas sectoriales productivas. Evaluación, competitividad y perspectvas de la economía real.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-building text-economista me-2"></i>
                          Desarrollo de políticas públicas
                        </h5>
                        <p className="card-text text-muted">
                          Consultoría técnica en finanzas públicas y macroeconomía aplicada, con enfoque en la gestión de coyuntura y sostenibilidad del sector público.     
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-cash-coin text-economista me-2"></i>
                          Proyectos de Inversión
                        </h5>
                        <p className="card-text text-muted">
                          Evaluación de factibilidad y estructuración de proyectos económicos complejos, integrando el análisis macro con las necesidades del inversor.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title">
                          <i className="bi bi-globe text-economista me-2"></i>
                          Mercado Financiero
                        </h5>
                        <p className="card-text text-muted">
                          Análisis de bonos soberanos, riesgo país, mercado cambiario y comportamiento 
                          de inversores institucionales.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </section>

      <section className="bio-content pt-1 pb-4">
        <ActividadProfesional />
      </section>

      {/* CTA Section */}
      <section className="bio-cta py-5">
        <div className="container text-center">
          <h2 className="h3 fw-bold mb-3">¿Necesitás asesoramiento económico?</h2>
          <p className="lead mb-4" style={{ color:' #eeeded' , marginBottom: '20px' }}>
            Disponible para consultoría, análisis de mercados y charlas sobre economía argentina
          </p>
          <a href="/#contacto" className="btn btn-lg px-5"
           style={{ 
                    backgroundColor: '#434242', 
                    color: 'white',
                    fontSize: '1rem',
                    fontWeight: '600',
                    transition: 'transform 0.2s'
                  }}
                  onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                  >
            Contactar
          </a>
        </div>
      </section>
      
    </div>
  );
}

export default Bio;